let MiniHomeScene = require('clover/scene/MiniHomeScene')
// let WorldScene = require('clover/scene/WorldScene')
// GameRevivePanel = require("clover/panel/GameRevivePanel")[1]
// TimeModeCountDown = require("clover/scene/component/gameplay/TimeModeCountDown")
// TimeModeWinPanel = require("activity/TimeModeActivity/TimeModeWinPanel")

var _homeScene
HomeScene = {
    created: false
}
HomeScene.getInstance = function () {
    if (!_homeScene) {
        _homeScene = MiniHomeScene.create(true)
        // _homeScene = WorldScene.create()
        _homeScene.retain()
        HomeScene.created = true
    }
    return _homeScene
}
HomeScene.getHomeScene = function () {
    return _homeScene
}
HomeScene.gotoWorldScene = function () {
    // TODO:
    // 1. load and create and goto WorldScene
    // 2. target _homeScene to WorldScene
}
HomeScene.exitWorldScene = function () {
    // TODO:
    // remove WorldScene
    // target _homeScene to mini
}

HomeScene.onViewChanged = function () {


}


module.exports = HomeScene